import { initializeApp } from 'firebase/app';
import { getAuth, OAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

const microsoftProvider = new OAuthProvider('microsoft.com');

// SECURITY: Set your Azure AD tenant ID here
// Using 'common' allows ANY Microsoft account - ONLY use for testing
// For production, use your specific tenant ID from Azure AD
// Example: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
const AZURE_TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID || 'common';

microsoftProvider.setCustomParameters({
  prompt: 'select_account',
  tenant: AZURE_TENANT_ID,
});

export const signInWithMicrosoft = async () => {
  try {
    const result = await signInWithPopup(auth, microsoftProvider);
    return result.user;
  } catch (error) {
    // Don't log full error details in production
    if (import.meta.env.DEV) {
      console.error('Microsoft sign-in error:', error);
    }
    throw error;
  }
};

export const signOutUser = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    // Don't log full error details in production
    if (import.meta.env.DEV) {
      console.error('Sign-out error:', error);
    }
    throw error;
  }
};
